import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalDevice = ({
  show,
  handleClose,
  device,
  selectedDevices,
  onChanged,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tempSelectedDevices, setTempSelectedDevices] = useState([]);
  const [isAllSelectedGlobal, setIsAllSelectedGlobal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const ITEMS_PER_PAGE = 7;

  useEffect(() => {
    if (show) {
      setTempSelectedDevices(selectedDevices);
      setIsAllSelectedGlobal(selectedDevices.length === device.length);
      setSearchTerm(""); // Reset pencarian saat modal dibuka
    }
  }, [show, selectedDevices, device]);

  const filteredDevices = device.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredDevices.length / ITEMS_PER_PAGE);
  const currentPageDevices = filteredDevices.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSelectDevice = (item, isChecked) => {
    let updatedSelection = isChecked
      ? [...tempSelectedDevices, item]
      : tempSelectedDevices.filter((d) => d.value !== item.value);
    setTempSelectedDevices(updatedSelection);
    setIsAllSelectedGlobal(updatedSelection.length === device.length);
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setTempSelectedDevices(filteredDevices);
      setIsAllSelectedGlobal(true);
    } else {
      setTempSelectedDevices([]);
      setIsAllSelectedGlobal(false);
    }
  };

  const handleConfirm = () => {
    onChanged(tempSelectedDevices);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Devices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Search Bar */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div></div> {/* Kosong untuk menjaga posisi */}
          <Form.Control
            type="text"
            placeholder="Search..."
            className="w-25"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* Tabel Data */}
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-custome">
            <thead>
              <tr className="text-white">
                <th className="p-2">
                  <input
                    type="checkbox"
                    checked={isAllSelectedGlobal}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </th>
                <th className="p-2">Device Name</th>
                <th className="p-2">MSISDN</th>
                <th className="p-2">Quota</th>
                <th className="p-2">Sending Period</th>
                <th className="p-2">Type</th>
                <th className="p-2">OSA Name</th>
              </tr>
            </thead>
            <tbody>
              {currentPageDevices.map((item) => {
                const isSelected = tempSelectedDevices.some(
                  (d) => d.value === item.value
                );
                return (
                  <tr
                    key={item.value}
                    onClick={() => handleSelectDevice(item, !isSelected)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="p-2">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={(e) =>
                          handleSelectDevice(item, e.target.checked)
                        }
                        onClick={(e) => e.stopPropagation()}
                      />
                    </td>
                    <td className="p-2">{item.name ? item.name : "-"}</td>
                    <td className="p-2">{item.msisdn}</td>
                    <td className="p-2">{item.quota}</td>
                    <td className="p-2">
                      {"Min " + item.min_period + " - Max " + item.max_period}
                    </td>
                    <td className="p-2">{item.type}</td>
                    <td className="p-2">
                      {item.osa_name ? item.osa_name : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          {totalPages > 1 && (
            <div>
              <Button
                variant="primary"
                className="btn btn-sm me-2"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </Button>
              <Button
                variant="primary"
                className="btn btn-sm"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          Close
        </Button>
        <Button variant="success" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDevice;
